import React, { useState } from 'react';
import { NotificationsHeader } from './components/NotificationsHeader';
import { NotificationTypesSidebar } from './components/NotificationTypesSidebar';
import { BannerConfiguration } from './components/BannerConfiguration';

export default function NotificationsPage() {
  const [selectedType, setSelectedType] = useState('banner');

  return (
    <div className='min-h-full bg-[#F5F5F5]'>
      <NotificationsHeader />

      <div className='px-10 pt-6 pb-10 flex flex-col h-[calc(100vh-140px)]'>
        {/* Main Content */}
        <div className='grid grid-cols-18 gap-3 h-full'>
          {/* Left Sidebar - Notification Types */}
          <NotificationTypesSidebar selectedType={selectedType} onTypeSelect={setSelectedType} />

          {/* Right Content - Configuration */}
          <BannerConfiguration />
        </div>
      </div>
    </div>
  );
}
